module.exports = __webpack_public_path__ + "img/wide.ebfdb619.jpg";